
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-check-outline",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-check-outline"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"i-check-outline__circle",attrs:{"cx":"9","cy":"9","r":"6.15"}}),_c('path',{staticClass:"i-check-outline__core",attrs:{"d":"M6.13 9.26l2.15 1.94 3.3-3.84"}})])
          )
        }
      }
    